import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { NewApiUserService } from '@brunsker/libs/portal-do-vendedor/utils/portal-do-vendedor-new-api';
import { ChangeAuthDomainService } from '@brunsker/libs/portal-do-vendedor/utils/portal-do-vendedor-new-api/lib/services/domain/change-auth/change-auth.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanLoad {
  sessionStorage = window.sessionStorage;
  constructor(
    private readonly newApiUserService: NewApiUserService,
    private readonly changeAuthDomainService: ChangeAuthDomainService,
    private readonly router: Router
  ) {}
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const isLoggedIn = await firstValueFrom(
      this.newApiUserService.currentUser$
    );

    this.changeAuthDomainService.start();
    if (isLoggedIn) return true;

    this.sessionStorage.clear();
    this.router.navigate(['/auth']);
    return false;
  }

  async canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> {
    const isLoggedIn = await firstValueFrom(
      this.newApiUserService.currentUser$
    );

    if (isLoggedIn) return true;

    this.sessionStorage.clear();
    this.router.navigate(['/auth']);
    return false;
  }
}
